import React from 'react';

export function Form(props) {
    const className = props.name || 'form';
    return <div className={className}>{props.children}</div>;
}

export function Column(props) {
    const className = props.name || 'form';
    return <div className={className + "__column"}>{props.children}</div>
}

class BaseInput extends React.Component {

    render() {
        const props = {...this.props};
        const className = props.name || 'form';
        let classes = className+'__input' + (props.readOnly ? ' ' + className + '__readonly' : '') + (props.class ? ' ' + props.class : '');
        if(props.error) classes += ' '+className+'__input_error';
        return [
            <input key="input" onFocus={props.onFocus} type="text" ref={props.forwardRef} className={classes} readOnly={(props.editable === undefined ? false : !props.editable)} value={props.value} onChange={props.onChange|| function() {}} placeholder={props.placeholder || props.title}/>,
            <Error key="error" error={props.error}/>
        ]
    }
}

export const DefaultInput = React.forwardRef((props, ref) => <BaseInput {...props} forwardRef={ref}/>);

export class DefaultTextArea extends React.Component {
    render() {
        const props = {...this.props};
        const className = props.name || 'form';
        let classes = className + '__input' + (props.readOnly ? ' '+className+'__readonly' : '');
        if(props.error) classes += ' form__input_error';
        return [
            <textarea onFocus={props.onFocus} key="input" className={classes} value={props.value} onChange={props.onChange || function(){}} rows={props.rows || 3} placeholder={props.placeholder || props.title}/>,
            <Error key="error" error={props.error}/>
        ]
    }

}



export function DefaultSelect(props) {
    const id = props.fieldId || 'id';
    const value = props.fieldValue || 'value';
    const onClick = props.onClick || function(){};
    const className = props.name || 'form';
    const data = props.data.map((item) => {
        return <span key={item[id]} className={className+"__list-item"} onMouseDown={() => onClick(item)}>{item[value]}</span>;
    });
    return <span className={className + "__list"}>
            {data}
        </span>
}

export function CheckBox(props) {
    const className = props.name || 'form';
    const classes = props.class ? className+'__checkbox ' + props.class : className+'__checkbox';
    const onChange = function() {
        if(props.onChange) {
            props.onChange(props);
        }
    };
    return <label className={classes}><input type="checkbox" checked={props.checked} onChange={onChange}/><span/>{props.value || ''}</label>
}



export function Row(props) {
    const Tag = props.tag || 'label';
    const className = props.name || 'form';
    let classes = props.class ? className+'__row ' + props.class : className+'__row';
    //if(props.error) classes += ' form__row_error';
    return <Tag className={classes + (props.readOnly ? " "+className+"__readonly" : '')}>
        <span className={className+"__label"}>{props.title}</span>
        {props.children}
    </Tag>
}

export class Input extends React.Component{

    render() {
        const p = {...this.props};

        if(p.editable === undefined)
            p.editable = true;
        // attribute

        if(p.readOnly === undefined)
            p.readOnly = false;

        return (
            <Row {...p}>
                <DefaultInput {...p} editable={!p.readOnly && p.editable} readOnly={!p.readOnly && !p.editable}/>
            </Row>
        );
    }

}

export function TextArea(props){
    return (
        <Row {...props}>
            <DefaultTextArea {...props}/>
        </Row>
    );
}


export class Select extends React.Component {

    constructor(props) {
        super(props);

    }

    render() {

        const id = this.props.fieldId || 'id';
        const val = this.props.fieldValue || 'value';

        const props = {...this.props};

        let value = props.value ? props.value.toString() : '';
        if(value) {
            let found = false;
            for (let i = 0; i < props.data.length; i++) {
                if (props.data[i][id].toString() === value) {
                    value = props.data[i][val];
                    found = true;
                    break;
                }
            }
            if(!found) value = '';
        }
        const onClick = (item) => {
            this.setState({
                value: item.value
            }, () => {
                if(this.props.onClick)
                    this.props.onClick(item);
            });
        };


        return (
            <Row {...props}>
                <DefaultInput {...props} value={value}/>
                <DefaultSelect {...props} onClick={onClick}/>
            </Row>
        );
    }
}

export const Error = (props) => {
    const className = props.name || 'form';
    if(!props.error)
        return '';
    return <p className={className+"__error"}>{props.error}</p>;
};


// WEBPACK FOOTER //
// ./bundle/form.js